import { ChecklistItemRecord } from "models/view-models/block-configurations/checklist-item-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";
import QueryHookFactory from "utilities/hooks/queries/query-hook-factory";

export interface ChecklistBlockConfigurationChecklistItemsPathParams {
    configurationId: number;
}

export interface ChecklistBlockConfigurationChecklistItemsQueryParams {}

const resourceEndpoint: string =
    "blocks/configurations/checklist/:configurationId/checklistItems";
const key = "block-configurations-checklist-checklistitems";

const resourceType = ChecklistItemRecord;

const ChecklistBlockConfigurationChecklistItemService = {
    key,
    useNestedList: ServiceHookFactory.useNestedList<
        ChecklistItemRecord,
        ChecklistBlockConfigurationChecklistItemsPathParams,
        ChecklistBlockConfigurationChecklistItemsQueryParams
    >(resourceType, resourceEndpoint),
    useListQuery: QueryHookFactory.useNestedListQuery<
        ChecklistItemRecord,
        ChecklistBlockConfigurationChecklistItemsPathParams,
        ChecklistBlockConfigurationChecklistItemsQueryParams
    >(key, resourceType, resourceEndpoint),
};

export default ChecklistBlockConfigurationChecklistItemService;
